import { Component, HostBinding, Input } from '@angular/core';
import { NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup } from '@angular/forms';
import { ReviewFormLineItemCondition } from '../../models/review-form/review-form-line-item-condition.model';
import { ReviewFormLineItemValue } from '../../models/review-form/review-form-line-item-value.model';
import { ReviewFormLineItem } from '../../models/review-form/review-form-line-item.model';
import { ReviewFormLineItemFlag } from '../../models/review-form/review-form-line-item-flag';
import { CustomAdapter } from '../../../core/classes/custom-adapter';
import { CustomDateParserFormatter } from '../../../core/classes/custom-date-parser-formatter';


@Component({
  selector: 'app-review-form-line-item',
  templateUrl: './review-form-line-item.component.html',
  styleUrl: './review-form-line-item.component.css',
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})
export class ReviewFormLineItemComponent {
  @Input() set lineItem(value: ReviewFormLineItem) {
    this.value = value?.value ?? null;
    this.required = value?.required ?? false;
    this.questionId = value?.id ?? 0;
    this.label = value?.label ?? '';
    this.conditions = value?.conditions ?? [];
    this.values = value.values ?? [];
    this.type = value?.type ?? 'none';
    this.item = value;
    this.flags = value?.flags ?? [];

    // Note: Older data has commas in the number and they need to be removed.
    if (this.type === 'number' && this.value != null) {
      this.value = `${this.value}`.replace(/[^\d.-]/g, '');
    }
  }

  @HostBinding('style.display') display: '' | 'none' = '';

  public value: string | null = null;

  public required: boolean = false;

  public questionId: number = 0;

  public label: string = '';

  public id: string = '';

  public formGroup!: FormGroup;

  public flagged: boolean = false;

  public values: ReviewFormLineItemValue[] = [];

  public conditions: ReviewFormLineItemCondition[] = [];

  public type: "none" | "yesno" | "textarea" | "datepicker" | "custom" | "number" | "detail" | "none" = "none";

  public item!: ReviewFormLineItem;

  public flags: ReviewFormLineItemFlag[] = [];

  constructor() {
  }

  public setIndex = (index: number) => {
    this.id = `line-item-${index.toString().padStart(2, '0')}`;
    return this;
  }

  public setFormGroup = (formGroup: FormGroup) => {
    this.formGroup = formGroup;
    return this;
  }

  public setDisplay = (display: boolean) => {
    this.display = display ? '' : 'none';
    return this;
  }
}
